<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-notes-medical"></i> Exame
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Exame*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>

                                <div class="col-md-4">
                                    <label>Data*</label>
                                    <input-datepicker
                                        :disabled="false"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.data"
                                    ></input-datepicker>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{'has-danger': $v.model.veterinario.$error }"
                                >
                                    <label>Veterinário*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.veterinario"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>CRMV/CBCK</label>
                                    <input
                                        type="text"
                                        maxlength="5"
                                        class="form-control"
                                        v-model="model.numeroInscricao"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Orientações</label>
                                    <textarea
                                        rows="5"
                                        cols="50"
                                        type="text"
                                        maxlength="1000"
                                        class="form-control"
                                        v-model="model.orientacao"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Clinica</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.clinica"
                                    />
                                </div>
                            </div>
                            <file-image v-model="file" :arquivo="model.arquivo"></file-image>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{name: 'list-exams-pet', params: { id: this.$route.params.id}}"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Collections from "@/helpers/collections";
import Select2 from "../../../components/Input/Select2";
import FileImage from "../../../components/Input/FileImage";
import SelectApi from "../../../components/Input/SelectApi";

export default {
    components: { Select2, FileImage, SelectApi },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                data: moment().format("YYYY-MM-DD"),
                veterinario: "",
                numeroInscricao: "",
                clinica: "",
                orientacao: "",
                arquivo: null,
                idPet: null
            },
            file: null
        };
    },
    validations() {
        return {
            model: {
                nome: {
                    required,
                    maxLength: maxLength(150),
                    minLength: minLength(2)
                },
                veterinario: {
                    required,
                    maxLength: maxLength(150),
                    minLength: minLength(2)
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;

            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            vm.model.idPet = this.$route.params.id;
            const formData = new FormData();
            formData.append("data", JSON.stringify(vm.model));
            formData.append("imagem", vm.file);

            if (vm.model.id) {
                let ret = facade.updateExam(formData, vm.model.id);
                ret.then(exam => {
                    this.$router.push({
                        name: "list-exams-pet",
                        params: {
                            id: this.$route.params.id,
                            idExam: this.$route.params.idExam
                        }
                    });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            } else {
                try {
                    let ret = facade.createExam(formData);
                    ret.then(exam => {
                        this.$router.push({
                            name: "list-exams-pet",
                            params: {
                                id: this.$route.params.id,
                                idExam: this.$route.params.id
                            }
                        });
                        this.$loading.show(false);
                    }).catch(e => {
                        e.forEach(item => {
                            this.$notify.error(item.field, item.message);
                        });
                        this.$loading.show(false);
                    });
                } catch (e) {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                }
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(exam) {
            let vm = this;
            if (exam !== undefined && exam !== null) {
                this.model = exam;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([
            to.params.idExam ? facade.getExam(to.params.idExam) : null
        ])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?a2f18b7c